export const NAV_COLOR = '#d9f4f0'
export const NAV_HEIGHT = 130
export const STORE_HEADER_HEIGHT = 209 // including global nav
